/**
 * Backend medya proxy (?size=) — MediaController / ImageOptimization varyantları.
 * Görsel sayısını azaltmadan transfer boyutunu düşürmek için viewport’a göre boyut seçin.
 */

export type MediaProxySize = 'medium' | 'large' | 'xlarge' | 'original';

export function appendMediaProxySize(url: string, size: MediaProxySize): string {
  if (!url || !url.includes('/api/media/proxy/')) {
    return url;
  }
  if (/[?&]size=/i.test(url)) {
    return url.replace(/([?&])size=[^&]*/i, `$1size=${size}`);
  }
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}size=${size}`;
}

/** The site deliberately serves at least large; defer downloads instead of reducing visual quality. */
export function ensureLargeMediaProxySize(url: string): string {
  const size = url.match(/[?&]size=([^&]+)/i)?.[1]?.toLowerCase();
  return size === 'xlarge' || size === 'original' ? url : appendMediaProxySize(url, 'large');
}

/** Hero / LCP: mobilde medium, tablet large, desktop xlarge */
export function pickResponsiveHeroSize(viewportWidth: number): MediaProxySize {
  if (viewportWidth < 640) return 'large';
  if (viewportWidth < 1024) return 'large';
  return 'xlarge';
}

/** Kart / liste görselleri */
export function pickResponsiveCardSize(viewportWidth: number): MediaProxySize {
  if (viewportWidth < 640) return 'large';
  return 'large';
}

/** SSR / ilk paint: ağır xlarge yerine güvenli varsayılan */
export const DEFAULT_HERO_SSR_SIZE: MediaProxySize = 'large';
